const defaultFields = () => ({
	name: null,
	description: null,
	duration: 1,
	price: 0,
	subservices: [],
})

const getBasePrice = async () => {
	try {
		let response = await axios.get('/settings');
		response = response.data.data.settings.recommended_base_price;
		return response === null ? 0 : response;
	} catch (e) {
		console.warn(e);
		return 0;
	}
}

export {
	defaultFields,
	getBasePrice,
}
